import React from "react";

import Svg, { Path, Circle } from "components/Svg";

const SafetyWater = props => (
	<Svg
		width={15 * props.scale}
		height={15 * props.scale}
		viewBox="0 0 512 512"
	>
		<Path
            fill={props.fill || "white"}
			d="M267.869,111.563c-2.841-3.677-7.225-5.83-11.871-5.83c-4.646,0-9.03,2.153-11.871,5.83
			c-3.564,4.615-87.315,113.973-87.315,195.505c0,54.693,44.496,99.188,99.187,99.188s99.186-44.495,99.185-99.188
			C355.184,225.536,271.433,116.178,267.869,111.563z M256,376.257c-38.15,0-69.187-31.038-69.187-69.188
			c0-54.368,46.675-128.245,69.192-160.717c22.517,32.448,69.18,106.264,69.182,160.717C325.187,345.22,294.15,376.257,256,376.257z"/>

        <Path
            fill={props.fill || "white"}
            d="M489.024,200.534C463.769,94.042,367.961,16.5,255.999,16.5c-95.888,0-184.705,57.638-222.083,149.83l-14.975-4.063
			c-11.13-3.023-21.376,7.171-18.428,18.313l14.883,56.247c2.94,11.11,16.872,14.957,25.073,6.804l41.266-41.014
			c8.185-8.132,4.474-22.099-6.645-25.116l-11.992-3.253C94.752,99.878,168.248,46.5,255.999,46.5
			c101.154,0,182.454,70.794,203.837,160.958c1.912,8.06,9.991,13.046,18.056,11.133
			C485.952,216.68,490.936,208.596,489.024,200.534z"/>

        <Path
            fill={props.fill || "white"}
            d="M511.485,331.419l-14.883-56.247c-2.952-11.155-16.904-14.926-25.073-6.803l-41.266,41.014
			c-8.185,8.132-4.474,22.099,6.645,25.116l11.992,3.253C417.245,412.122,343.749,465.5,255.999,465.5
			c-101.154,0-182.454-70.794-203.837-160.958c-1.912-8.06-9.988-13.045-18.056-11.133c-8.06,1.911-13.044,9.995-11.132,18.057
			C48.228,417.958,144.036,495.5,255.999,495.5c95.888,0,184.705-57.638,222.083-149.83l14.975,4.063
			C504.132,352.741,514.45,342.624,511.485,331.419z"/>
	</Svg>
);

export default SafetyWater;



// WEBPACK FOOTER //
// ./src/components/svgs/SafetyWater/index.js